/**
 *
 * @returns {Promise<any|{success: boolean}>}
 */
export const shopSettings = async () => {
  try {
    const response = await fetch('get/api/shop/settings', {
      method: 'get',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error('Something went wrong')
    }

    return await response.json()
  } catch (error) {
    console.error(error)
  }

  return {
    success: false,
  }
}
